import React from "react";

const Skeleton = () => (
  <div className="skeleton">
    <div className="skeleton-avatar"></div>
    <div className="skeleton-author"></div>
    <div className="skeleton-details"></div>
  </div>
);

export default Skeleton;
